import { css } from 'styled-components'

export const breakpoints = {
  mobile: 480,
  tablet: 768,
  desktop: 1024,
}

// Usage: ${media.tablet`margin: 20px;`} applies styles at <= 768px
export const media = Object.keys(breakpoints).reduce((acc, key) => {
  acc[key] = (...args) => css`
    @media (max-width: ${breakpoints[key]}px) {
      ${css(...args)}
    }
  `
  return acc
}, {})

export default media
